var Verify2Component = /** @class */ (function () {
    function Verify2Component() {
    }
    Verify2Component.prototype.ngOnInit = function () {
    };
    return Verify2Component;
}());
export { Verify2Component };



// WEBPACK FOOTER //
// ./src/app/verify2/verify2.component.ts.pre-build-optimizer.js